import type { AccountDetail } from '@/api/accounts';

/** EAA-1820 (frame 72): human label for the profile header and breadcrumb. */
export function accountDisplayName(
    detail: Pick<AccountDetail, 'first_name' | 'last_name' | 'username' | 'email'>
): string {
    const parts = [detail.first_name, detail.last_name].filter(Boolean);
    if (parts.length > 0) return parts.join(' ');
    return detail.username || detail.email || '—';
}

export default accountDisplayName;
